import styled from 'styled-components'

import { IconInfo } from 'components/Icons/InfoIcon'
import { Typography } from 'components/Typography/Typography'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { useIsMobile } from 'utils/useIsMobile'

const DetailsInfoContainerItem = styled.div`
  padding: 24px;
  border-radius: 16px;
  border: 0.7px solid ${p => p.theme.colors.divider};
  background: ${p => p.theme.colors.background.primary};
  box-shadow: 0px 0px 16px 0px ${p => p.theme.colors.background.hover};
  margin-top: 24px;
`

const OverviewRow = styled.div`
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

const OverviewItem = styled.div`
  flex: 1 1 33.33%;
  box-sizing: border-box;

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    flex: 1 1 50%;
  }
  .centerSvg {
    > div {
      display: flex;
      cursor: pointer;
    }
  }
`

interface Props {
  utilization?: string
  maxWithdrawable?: string
}

export const Allocation = ({ utilization, maxWithdrawable }: Props) => {
  const isMobile = useIsMobile()

  return (
    <DetailsInfoContainerItem>
      {isMobile ? (
        <>
          <OverviewRow>
            <OverviewItem>
              <Typography variant="caption" color="secondary" style={{ marginBottom: 12 }}>
                % Allocation
              </Typography>
              <Typography variant="description" fontWeight="bold">
                Kai Leverage (100%)
              </Typography>
            </OverviewItem>
          </OverviewRow>
          <OverviewRow>
            <OverviewItem>
              <Typography variant="caption" color="secondary" style={{ marginBottom: 12 }}>
                % Utilization
              </Typography>
              <Typography variant="description" fontWeight="bold">
                {utilization}
              </Typography>
            </OverviewItem>
            <OverviewItem>
              <Typography variant="caption" color="secondary" style={{ marginBottom: 12 }}>
                Max Withdrawable
              </Typography>
              <Typography variant="description" fontWeight="bold">
                {maxWithdrawable}
              </Typography>
            </OverviewItem>
          </OverviewRow>
        </>
      ) : (
        <>
          <OverviewRow>
            <OverviewItem>
              <Typography
                variant="body"
                color="secondary"
                style={{ marginBottom: 24, display: 'flex', alignItems: 'center' }}
                className="centerSvg"
              >
                % Allocation
                <Tooltip
                  content="Shows how vaults assets are distributed across different strategies within the vault."
                  position="top"
                >
                  <IconInfo width={16} height={16} style={{ marginLeft: 6 }} />
                </Tooltip>
              </Typography>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <span>Kai Leverage (100%)</span>
              </Typography>
            </OverviewItem>
          </OverviewRow>
          <OverviewRow style={{ marginTop: 32 }}>
            <OverviewItem>
              <Typography
                variant="body"
                color="secondary"
                style={{ marginBottom: 24, display: 'flex', alignItems: 'center' }}
                className="centerSvg"
              >
                % Utilization
                <Tooltip
                  content="The percentage of deposited assets currently locked in active strategies and unavailable for withdrawal."
                  position="top"
                >
                  <IconInfo width={16} height={16} style={{ marginLeft: 6 }} />
                </Tooltip>
              </Typography>
              <Typography variant="subtitle2" fontWeight="bold">
                {utilization}
              </Typography>
            </OverviewItem>
            <OverviewItem>
              <Typography
                variant="body"
                color="secondary"
                style={{ marginBottom: 24, display: 'flex', alignItems: 'center' }}
                className="centerSvg"
              >
                Max Withdrawable
                <Tooltip content="The maximum amount that can currently be withdrawn from the vault." position="top">
                  <IconInfo width={16} height={16} style={{ marginLeft: 6 }} />
                </Tooltip>
              </Typography>
              <Typography variant="subtitle2" fontWeight="bold">
                {maxWithdrawable?.toString()}
              </Typography>
            </OverviewItem>
          </OverviewRow>
        </>
      )}
    </DetailsInfoContainerItem>
  )
}
